import PrivateFlowGate from "modules/projects/elements/Private-Flow-Wrapper";
import NewProjectLayout from "modules/projects/elements/New-Project-Entitlement-Wrapper";

import * as flowConfig from "flows/impact-analysis-binary/config";
import CreateNewProject from "flows/impact-analysis-binary/views/create-project";

const CreateProject = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <div className="pb-4 mb-8">
        <h1 className="h2 text-center">
          Start Impact Analysis (Binary Outcome) Project
        </h1>
      </div>
      <CreateNewProject />
    </div>
  );
};

CreateProject.getLayout = (page) => (
  <PrivateFlowGate flowName={flowConfig.FLOW_NAME}>
    <NewProjectLayout>{page}</NewProjectLayout>
  </PrivateFlowGate>
);

export default CreateProject;
